import axios from "../api/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, PRODUCT_SLUG } from "../config";
const cookies = new Cookies();

const usePut = (formPostObject) => {
  const queryClient = useQueryClient();
  const { url, onSuccess, onError, onSettled, refreshUrl } = formPostObject;
  const handleAuth = useMutation({
    mutationFn: (data) => handleFormSubmit(data),
    onSuccess: (data) => {
      onSuccess?.(data);
      if (refreshUrl) {
        // Handle both single URL and array of URLs
        if (Array.isArray(refreshUrl)) {
          refreshUrl.forEach((url) => {
            queryClient.invalidateQueries([url]);
          });
        } else {
          queryClient.invalidateQueries([refreshUrl]);
        }
      }
    },
    onError: (err) => {
      onError?.(err);
    },
    onSettled: () => {
      onSettled?.();
    },
  });
  const handleFormSubmit = async (getFormData) => {
    let token = cookies.get(TOKEN_NAME);
    let fd = new FormData();
    fd.append("company_id", cookies.get(COMPANY_ID));
    fd.append("product_slug", PRODUCT_SLUG);

    for (var key in getFormData) {
      if (key === "document" || key === "document[]") {
        fd.append(key, getFormData[key]);
      } else if (key === "month_year") {
        fd.append(key, getFormData[key]);
      } else {
        if (
          Array.isArray(getFormData[key]) ||
          typeof getFormData[key] === "object"
        ) {
          fd.append(key, JSON.stringify(getFormData[key]));
        } else {
          fd.append(key, getFormData[key]);
        }
      }
    }

    const response = await axios({
      method: "POST",
      url: `/${url}`,
      data: fd,
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    return response;
  };
  return {
    handleAuth,
    isLoading: handleAuth.isLoading, // Loading state for the mutation
  };
};

export default usePut;
